import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DefaultLanguageId, Modalconfig } from 'src/app/shared/constants';
import { Location } from '@angular/common';
import { CommonHttpService } from 'src/app/shared/services/common-http/common-http.service';
import { PlaybookCommunicationService } from '../../services/playbook-communication.service';
import { ConfirmationModelComponent } from 'src/app/shared/components/confirmation-model/confirmation-model.component';
import { SessionStorageService } from 'src/app/shared/services/session-storage/session-storage.service';
import { sessionProfile } from 'src/app/shared/interfaces/sessionStorageModel';
import { orderBy, map } from 'lodash';
import { SendIframeUrlService } from 'src/app/shared/services/send-iframe-url/send-iframe-url.service';

@Component({
    selector: 'app-undo-redo',
    templateUrl: './undo-redo.component.html',
    styleUrls: ['./undo-redo.component.scss'],
    standalone: false
})
export class UndoRedoComponent implements OnInit {

  playbookId: number;
  languageId: number;
  undoHistory: Array<any> = [];
  redoHistory: Array<any> = [];
  confirmationModalRef: BsModalRef;
  vBuilderRedirectURl: any;
  templateUrl: string;
  pageFrom;
  private loggedInProfile: sessionProfile;
  constructor(
    private commonHttpService: CommonHttpService,
    private commService: PlaybookCommunicationService,
    private location: Location,
    private modalService: BsModalService,
    private sessionStorageService: SessionStorageService,
    private modalRef: BsModalRef,
    private sendIframeUrlService: SendIframeUrlService
  ) { }
  ngOnInit() {
    this.getUndoRedoHistory();
    this.loggedInProfile = this.sessionStorageService.getLoggedInProfileDetail();
  }
  closeUndoRedoPopUp() {
    this.modalRef.hide();
  }
  getUndoRedoHistory() {
    this.commonHttpService.get({
      uri: `/api/Playbooks/GetUndoRedoHistory?playbookId=${this.playbookId}`
    }).subscribe((undoHistory: Array<any>) => {
      this.redoHistory = [];
      this.undoHistory = [];
      const undoHistorySorted = orderBy(undoHistory, ['id'], ['desc']);
      map(undoHistorySorted, (eachUndoHistorySorted) => {
        eachUndoHistorySorted.languageId = eachUndoHistorySorted.languageId === null ? DefaultLanguageId : eachUndoHistorySorted.languageId;
        eachUndoHistorySorted.isRedo
          ? this.redoHistory.push(eachUndoHistorySorted) : this.undoHistory.push(eachUndoHistorySorted)
      });
    });
  }

  checkUser(undoData, isUndo) {
    const initialState = {
      msg: `Are you sure you want to undo the last changes made by ${undoData.createdByName}?`
    };
    this.confirmationModalRef = this.modalService.show(ConfirmationModelComponent,
      Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));

    this.confirmationModalRef.content.onclose.subscribe((isDelete: boolean) => {
      if (isDelete) {
        if (isUndo) {
          this.undoApiCall(undoData);
        } else {
          this.redoApiCall(undoData);
        }
      }
      this.confirmationModalRef.hide();
    });
  }
  undoApi(index, undoData) {
    if (!index) {
      if (undoData.createdBy === this.loggedInProfile.id) {
        this.undoApiCall(undoData);
      } else {
        this.checkUser(undoData, true);
      }
    }
  }
  undoApiCall(undoData) {
    this.commonHttpService.postWithHeaders({
      uri: `/api/Playbooks/Undo?playbookId=${undoData.playbookId}&languageId=${undoData.languageId}`,
      message: {
        errorMessage: 'Something went wrong. Please try again'
      }
    }, {
      pageId: undoData.pageId,
      sectionId: undoData.sectionId,
      playbookId: undoData.playbookId,
      languageId: undoData.languageId,
      isdraftmode: undoData.isDraftMode
    }).subscribe((undoApiData) => {
      this.commService.setUndoRedoManifest(undoData);
      this.getUndoRedoHistory();
    });
  }
  redoApi(index, redoData) {
    if (!index) {
      if (redoData.createdBy === this.loggedInProfile.id) {
        this.redoApiCall(redoData);
      } else {
        this.checkUser(redoData, false);
      }
    }
  }
  redoApiCall(redoData) {
    this.commonHttpService.postWithHeaders({
      uri: `/api/Playbooks/Redo?playbookId=${redoData.playbookId}&languageId=${redoData.languageId}`,
      message: {
        errorMessage: 'Something went wrong. Please try again'
      }
    }, {
      pageId: redoData.pageId,
      sectionId: redoData.sectionId,
      playbookId: redoData.playbookId,
      languageId: redoData.languageId,
      isdraftmode: redoData.isDraftMode
    }).subscribe((redoApiData) => {
      this.commService.setUndoRedoManifest(redoData);
      this.getUndoRedoHistory();
    });
  }

  goToSection(undoData) {
    const url = `/playbookeditor/${undoData.playbookId}${undoData.pageId
      ? '/page/' + undoData.pageId : ''}${undoData.sectionId ? '/section/' + undoData.sectionId
        : ''}?languageId=${undoData.languageId}${this.vBuilderRedirectURl ? '&r=' + this.vBuilderRedirectURl : ''}${this.templateUrl 
          ? '&templateUrl=' + this.templateUrl : ''}${this.pageFrom ? '&pageFrom=' + this.pageFrom : ''}`;
    this.location.go(url);
    this.commService.sendCurrentSectionId(undoData.sectionId ? undoData.sectionId : null);
    this.commService.sendCurrentPageId(undoData.pageId);
    this.sendIframeUrlService.sendUrlToParent(url);
    if (undoData.languageId !== this.languageId) {
      window.location.href = window.location.origin + url;
    }
  }
}
